module.exports = __webpack_public_path__ + "img/mount8.403e9acb.jpg";